import { Service, ServiceInitializer } from '@estee/elc-service';

const { name, version } = __serviceInfo__;

export class AnalyticsService extends Service {
    constructor(serviceIntializer: ServiceInitializer) {
        super(name, version, serviceIntializer);
    }
}
